import LoadImgs from './loadImgs';
import webpUrl from './webpUrl';
import { utils as coreUtils } from '@didi/webx-js-core';
import PageShow from './pageShow';
import { setEncrypt } from './encrypt';
import { is } from '../xenv';
import { weixinReady } from '../platform/xenv/_common/weixin';
import { getEncryptPublicKey } from './encrypt/get_public_key';
const pageShow = new PageShow();
/**
 * 重置字体大小，防止在微信 h5 和微信小程序内嵌 h5 中字体大小随微信设置中的字体大小变化而变化
 */
const resetFontSize = () => {
    if (is('weixin')) {
        if (is('ios')) {
            const resetFontSizeStyleDom = document.createElement('style');
            resetFontSizeStyleDom.innerHTML = `body {
        -webkit-text-size-adjust: 100% !important;
        text-size-adjust: 100% !important;
      }`;
            document.body.insertBefore(resetFontSizeStyleDom, document.body.firstChild);
        }
        weixinReady(wx => {
            wx?.invoke?.('setFontSizeCallback', { 'fontSize': 2 });
            // 重写设置网页字体大小的事件
            wx?.on?.('menu:setfont', function () {
                wx?.invoke?.('setFontSizeCallback', { 'fontSize': 2 });
            });
        });
    }
};
const copy = (text) => {
    const input = document.createElement('input');
    input.readOnly = true;
    input.style.opacity = '0';
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    try {
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => {
                console.log('=======剪切板复制成功========= ', text);
            }).catch(() => {
                document.execCommand('Copy');
            });
        }
        else {
            document.execCommand('Copy');
        }
    }
    catch (e) {
        //
    }
    document.body.removeChild(input);
};
const utils = {
    ...coreUtils,
    setEncrypt,
    getEncryptPublicKey,
    resetFontSize,
    LoadImgs,
    webpUrl,
    copy,
    pageShow
};
export { utils };
